<template>
  <v-row justify="center">
    <v-col cols="12">
      <h2 class="text-h5 mb-1">{{ languageData.labels.invoice }} {{ invoice.number }}</h2>
      <p class="text-h6">{{ languageData.labels.remainingAmountToPay + ':'}} {{ invoice.remainingAmountToPay }}</p>
      <v-form ref="paidAtForm">
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="invoiceData.paidAt"
                :label="languageData.labels.is_invoice_paid"
                prepend-inner-icon="mdi-calendar"
                readonly
                :rules="[
                  v => !!v || languageData.validatePaidAtForm.paid_at_required,
                ]"
                v-bind="attrs"
                v-on="on"
                outlined
                clearable
                :clear-icon-cb="clearText"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="invoiceData.paidAt"
              no-title
              scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="menu = false"
            >
              {{ languageData.cancel }}
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="$refs.menu.save(invoiceData.paidAt)"
            >
              {{ languageData.btnAgreeText }}
            </v-btn>
          </v-date-picker>
        </v-menu>
        <input hidden> <!-- Only for bypass form submission on enter -->
        <v-text-field
            type="number"
            height="55px"
            outlined
            :rules="[v => !!v || languageData.validatePaidAtForm.paymentAmountRequired]"
            :placeholder="languageData.labels.paymentAmount"
            v-model="invoiceData.paymentAmount"
            :label="languageData.labels.paymentAmount"
            prepend-inner-icon="euro"
        ></v-text-field>
        <div class="d-flex justify-end">
          <v-btn
              class="mr-2"
              color="primary"
              outlined
              @click="cancelForm">
            {{ languageData.btnCancel }}
          </v-btn>
          <v-btn
              color="primary"
              :loading="isLoading"
              @click="acceptPaidAt">
            {{ languageData.btnAccept }}
          </v-btn>
        </div>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import eventBus from "../../../../event-bus/eventBus";

export default {
  name: "InvoicePaidForm",
  props: {
    invoice: Object,
  },
  data() {
    return {
      invoiceData: {
        paidAt: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },
      menu: false,
    }
  },
  computed: {
    ...mapState("paymentInvoice", {
      isLoading: state => state.isLoading
    }),
  },
  methods: {
    ...mapActions('paymentInvoice', ["invoiceIsPaid"]),
    ...mapActions('updateVisibleInvoicePaidAtModal', ["updateVisibleInvoicePaidAtModal"]),
    acceptPaidAt() {
      if(this.$refs.paidAtForm.validate()) {
        this.invoiceIsPaid({creds: {invoice: this.invoice, paidAt: this.invoiceData.paidAt, paymentAmount: this.invoiceData.paymentAmount}})
      }
    },
    cancelForm() {
      this.updateVisibleInvoicePaidAtModal(false);
    },
    clearText() {
      this.$refs.paidAtForm.reset();
    }
  },
  mounted() {
    eventBus.$on("invoicePaidAtSuccess", () => {
      this.invoiceData.paidAt = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    })
  }

}
</script>